module.exports = __webpack_public_path__ + "img/xp.13590ed4.png";